import { inject } from '@angular/core';
import { PermissionService } from '@core/services/permission.service';

export const canMatchPermission = (
  routeName: string,
  permissionService = inject(PermissionService)
) => permissionService.getPagePermissions(routeName);
